<div 
[ngClass]="theme.getThemeClass()"
class="main-container">
<div class="closeBTN">
 <span
 (click)="closeModal()" 
 ><i class="fa-solid fa-xmark"></i></span>
</div>
    <div class="modalBody">
        <aside>
            <!-- <ul class="navList">
                <li class="navItem" (click)="navigate(1)">Customer Name: {{clientContact.client_name}}</li>
                <li class="navItem" (click)="navigate(2)">Customer location: {{clientContact.address }}</li>
                <li class="navItem" (click)="navigate(3)">Customer phone: {{clientContact.phone_number}}</li>
            </ul> -->
            <ul class="contactList"> <!-- UPDATE UI one api plugged -->
                @for (contact of contacts; track contact.user) {
                    <li class="contact" (click)="openConversation(contact.user);selectContact(contact)">
                        <span class="circle"  >{{contact.given_name[0]}}</span>
                        <span class="name"> {{contact.given_name + ' ' + contact.family_name }}</span>
                    </li>

                }
            </ul>
        </aside>
        <section class="modelBody">
            <article class="modalTab" [hidden]="communiation">
                <div class="chat-container">
                    <!-- TO DO
                    change the check to user sub once WS implemented line 25 
                    -->
                   
                    <div class="messages">
                        <!-- <header class="contactInfo">
                            <span class="circle"> j</span>
                            <span> james callahan</span>
                        </header> -->
                      @for (message of chatLog.reverse(); let i = $index; track i) {
                      <div class="messageLine" 
                      [ngStyle]="{'justify-content': message.owner === 1 ? 'flex-end' : 'flex-start'}"
                      >
                        <div class="messageContainer">
                            <span class="message">
                                {{message.message}}
                            </span>
                        </div>
                      </div>
                      }
                      
                    </div>
                    <input class="messageBar" [(ngModel)]="newMessage" placeholder="Type a message" />
                    <button (click)="sendMessage()">Send</button>
                  </div>
            </article>
            <article class="modalTab" [hidden]="position">location</article>
           <!--  <article class="modalTab"></article> -->
        </section>
    </div>
</div>
